<app-expert-group-portal-header
  *ngIf="expertGroupPortal"
  selectedNavItem="resources"
  [expertGroupPortal]="expertGroupPortal"
></app-expert-group-portal-header>

<app-expert-group-portal-resources-tabs
  *ngIf="tabSlug && expertGroupPortal"
  [selectedTabItem]="tabSlug"
  [expertGroupPortal]="expertGroupPortal"
></app-expert-group-portal-resources-tabs>
<div class="container" *ngIf="!loader">
  <div class="columns is-multiline" *ngIf="featuredCards.length">
    <div
      class="column is-4-tablet is-3-desktop"
      *ngFor="let featuredCard of featuredCards"
    >
      <app-featured-card
        [featuredCard]="featuredCard"
        [layout]="FeaturedCardLayout.Vertical"
      ></app-featured-card>
    </div>
  </div>

  <div class="columns is-multiline" *ngIf="!featuredCards.length">
    <div class="column is-4-tablet is-3-desktop">
      <p>No {{ tabSlug }} found.</p>
    </div>
  </div>
</div>

<!--  Loader -->
<div class="container" *ngIf="loader">
  <app-resources-loader></app-resources-loader>
</div>
